import { CenterOlPayment } from '../../lib/types/models/center-ol-payment/center-ol-payment'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenterOlPayment(id: number) {
  return restApiClient
    .url(constructApiUrl(API.centerOlPayments.get.url, { id }))
    .get<CenterOlPayment>()
}
